export default function Footer() {
  return (
    <footer className="bg-white border-t-4 border-nhs-blue mt-8" aria-label="Site footer">
      <div className="mx-auto max-w-[880px] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 px-4 lg:px-6 py-4">
        <div className="flex items-center gap-3 flex-wrap text-text-muted text-sm">
          <span>Powered by</span>
          <a
            href="https://acceleraate.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Acceleraate (opens in a new tab)"
            className="inline-flex items-center"
          >
            <img
              src="/images/logo-acceleraate-blue.svg"
              alt="Acceleraate"
              className="h-[30px] w-auto block"
            />
          </a>
          <span aria-hidden="true" className="text-[#c8d1d4]">
            ·
          </span>
          <a
            href="https://zoom.us"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Zoom (opens in a new tab)"
            className="inline-flex items-center"
          >
            <img src="/images/zoom.png" alt="Zoom" className="h-[18px] w-auto block" />
          </a>
        </div>
        <a
          href="https://www.surreyandsussex.nhs.uk/about-us/corporate-and-regulatory-information/privacy-policy"
          className="text-sm text-nhs-blue underline hover:no-underline"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Privacy policy (opens in a new tab)"
        >
          Privacy policy
        </a>
      </div>
    </footer>
  );
}
